// 网站配置
// 修改此文件来更改网站标题、描述等信息

export const siteConfig = {
  // 网站名称（用于主标题、Logo等）
  name: '赛智云',
  // 网站短名称（用于PWA、小空间显示）
  shortName: 'SR2Hub',
  // 网站标题后缀（用于浏览器标签页标题）
  titleSuffix: '文件管理系统',
  // 网站副标题/描述
  subtitle: 'oss文件管理系统',
  // 网站详细描述（用于SEO、分享等）
  description: '基于 Cloudflare 部署的多厂商 OSS 文件管理系统，支持 WebDAV、预签名直传、安全分享',
  // 作者
  author: 'OSSshelf',
  // 分享页面标题
  shareTitle: '文件分享',
  // 底部版权信息
  footerText: '文件管理系统',
  // PWA提示文字
  pwaPromptText: '将SR2Hub添加到主屏幕，获得更好的使用体验',
  // Powered by 文字
  poweredBy: 'Powered by',
} as const;

export type SiteConfig = typeof siteConfig;
